import { motion } from "framer-motion";
import Image from "next/image";

import { ShowcaseArtist } from "@/types/defs/conversionShowcase";
import { cn } from "@/utils/cn";

export function ConversionShowcaseVoiceOption({
  artist,
  isSelected,
  onSelect,
  registerToRef,
  variant,
}: {
  artist: ShowcaseArtist;
  isSelected: boolean;
  onSelect: () => void;
  registerToRef: (artistId: string, el: HTMLElement | null) => void;
  variant: "mobile" | "desktop";
}) {
  const isDesktop = variant === "desktop";

  return (
    <button
      type="button"
      ref={(el) => {
        registerToRef(artist.id, el);
      }}
      onClick={onSelect}
      className={cn(
        "flex h-9 w-full items-center gap-2",
        isDesktop &&
          "gap-3 rounded-full px-4 text-sm font-medium transition-all",
        isDesktop &&
          (isSelected ?
            "bg-gray-900 text-white"
          : "bg-gray-100 text-gray-700 hover:bg-gray-200")
      )}
    >
      {isDesktop ?
        <Image
          src={artist.image}
          alt={artist.name}
          width={28}
          height={28}
          className="h-6 w-6 shrink-0 rounded-full object-cover"
        />
      : <motion.div
          className="relative h-9 w-9 shrink-0 overflow-hidden rounded-full"
          whileTap={{ scale: 0.92 }}
        >
          <Image
            src={artist.image}
            alt={artist.name}
            fill
            className="object-cover"
          />
        </motion.div>
      }
      <span
        className={cn(
          "truncate text-sm font-medium transition-colors",
          !isDesktop && (isSelected ? "text-gray-900" : "text-gray-400")
        )}
      >
        {artist.name}
      </span>
    </button>
  );
}
